import { FC } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { useRateFieldName } from "../../hooks/useRateFieldName";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardChip } from "@/dashboard-design-system/DashboardChip";
import { DashboardTooltip } from "@/dashboard-design-system/DashboardTooltip";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";
import { Hide } from "@/icons/outlined";

export const HiddenChip: FC = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<StepTicketsFormData>();

  const isHidden = useWatch({ control, name: useRateFieldName("isHidden") });

  if (!isHidden) {
    return null;
  }

  return (
    <DashboardTooltip title={t("dashboard", "ticketing.shopItem.hiddenTooltip")}>
      <DashboardChip
        vibe="warning"
        variant="outlined"
        icon={<Hide />}
        label={t("dashboard", "ticketing.shopItem.hiddenChip")}
        data-test="card-hidden-chip"
      />
    </DashboardTooltip>
  );
};
